import React, { useState } from "react";

import Footer2 from "components/Footers/Footer2";
import AdminNavbar from "components/Navbars/AdminNavbar";

import blog1 from "assets/img/blog1.jpg";
import blog2 from "assets/img/blog2.jpg";
import blog3 from "assets/img/blog3.jpg";
import blog4 from "assets/img/blog4.jpg";
import blog5 from "assets/img/blog5.jpg";
import blog6 from "assets/img/blog6.jpg";
import contact from "assets/img/contact.png";
import calendar1 from "assets/img/calendar1.png";
import folder from "assets/img/folder.png";
import bgg from "assets/img/bgg.png";
import bfly1 from "assets/img/bfly1.webp";
import clouds from "assets/img/clouds.webp";
export default function GridBlog() {
  return (
    <>
      <AdminNavbar fixed />

      <section
        className=" parkinsans xl:block lg:block md:hidden sm:hidden hidden xl:h-400"
        style={{
          backgroundColor: "#f0f7fa",
          backgroundImage: `url(${bgg})`,
          backgroundPosition: "center center",
          backgroundRepeat: "repeat",
          backgroundSize: "35% auto",
        }}
      >
        <div className=" container mx-auto gap-6 xl:px-0 px-4">
          <div className=" flex justify-start top-0 absolute right-0 ">
            <img
              className="xl:w-32 lg:w-32 md:w-32 w-20 xl:pt-0 lg:pt-0 md:pt-8 pt-16"
              src={clouds}
              alt=""
            />
          </div>
        </div>
        <div>
          <h1 className="xl:text-6xl lg:text-5xl md:text-4xl text-2xl text-black text-center font-bold xl:pt-48 lg:pt-40">
            Blog
          </h1>
        </div>
        <div>
          <div className=" ">
            <img className="xl:w-44 w-32 " src={bfly1} alt="" />
          </div>
        </div>
      </section>

       {/* tab and mobile */}
      <section
        className=" parkinsans xl:hidden lg:hidden md:block sm:block block md:h-320"
        style={{
          backgroundColor: "#f0f7fa",
          backgroundImage: `url(${bgg})`,
          backgroundPosition: "center center",
          backgroundRepeat: "repeat",
          backgroundSize: "35% auto",
        }}
      >
        <div className=" container mx-auto gap-6 xl:px-0 px-4">
          <div className=" flex justify-start top-0 absolute right-0 pt-16 ">
            <img
              className=" md:w-24 w-12 md:pt-8"
              src={clouds}
              alt=""
            />
          </div>
        </div>
        <div>
          <h1 className="md:text-4xl text-3xl text-black text-center font-bold md:pt-44 pt-32">
            Blog
          </h1>
        </div>
        <div>
          <div className=" ">
            <img className=" md:w-32 w-20 " src={bfly1} alt="" />
          </div>
        </div>
      </section>



      
      <section className="container mx-auto xl:px-0 px-4">
        <div class="grid xl:grid-cols-3 lg:grid-cols-3 md:grid-cols-2 grid-cols-1 gap-6 xl:mt-12 xl:pb-16 lg:mt-12 pb-16 mt-12">
          <div>
            <div class=" rounded  shadow-lg bg-white xl:p-8 lg:p-6 p-6">
              <div class="image-container1">
                <img class="xl:w-12/12 w-12/12 rounded" src={blog1} alt="Blog Image" />
                <button class="exam-button flex">
                  <div>
                    <img className="w-6" src={folder} alt="" />
                  </div>
                  <span className="ml-2">Exam</span>
                </button>
              </div>

              <div class="xl:pt-4 pt-4" >
                <div className="flex gap-6 justify-between">
                  <div className="flex gap-2">
                    <div>
                      <img class="w-4" src={calendar1} alt="" />
                    </div>
                    <p className=" text-sm">May 16, 2024</p>
                  </div>

                  <div className="flex gap-2">
                    <div>
                      <img class="w-4" src={contact} alt="" />
                    </div>
                    <p className="text-sm">By JuniorToes</p>
                  </div>
                </div>
                <h2 class="font-bold  xl:pt-6 xl:text-2xl text-xl text pt-4">
                  All Inclusive Ultimate Circle Island Day
                </h2>
              </div>
              <div class="xl:pt-6 pt-4 flex justify-between items-center">
                <a
                  href="/grid"
                  class="text-peach text text-base font-semibold"
                >
                  Read More ➜
                </a>
              </div>
            </div>
          </div>

          <div>
            <div class=" rounded  shadow-lg bg-white xl:p-8 lg:p-6 p-6">
              <div class="image-container1">
                <img class="xl:w-12/12 w-12/12 rounded" src={blog2} alt="Blog Image" />
                <button class="exam-button flex">
                  <div>
                    <img className="w-6" src={folder} alt="" />
                  </div>
                  <span className="ml-2">Exam</span>
                </button>
              </div>

              <div class="xl:pt-4 pt-4">
                <div className="flex gap-6 justify-between">
                  <div className="flex gap-2">
                    <div>
                      <img class="w-4" src={calendar1} alt="" />
                    </div>
                    <p className=" text-sm">May 16, 2024</p>
                  </div>

                  <div className="flex gap-2">
                    <div>
                      <img class="w-4" src={contact} alt="" />
                    </div>
                    <p className="text-sm">By JuniorToes</p>
                  </div>
                </div>
                <h2 class="font-bold  xl:pt-6 pt-4 xl:text-2xl text text-xl">
                  All Inclusive Ultimate Circle Island Day
                </h2>
              </div>
              <div class="xl:pt-6 pt-4 flex justify-between items-center">
                <a
                  href="/grid"
                  class="text-peach text text-base font-semibold"
                >
                  Read More ➜
                </a>
              </div>
            </div>
          </div>

          <div>
            <div class=" rounded  shadow-lg bg-white xl:p-8 lg:p-6 p-6">
              <div class="image-container1">
                <img class="xl:w-12/12 w-12/12 rounded" src={blog3} alt="Blog Image" />
                <button class="exam-button flex">
                  <div>
                    <img className="w-6" src={folder} alt="" />
                  </div>
                  <span className="ml-2">Exam</span>
                </button>
              </div>

              <div class="xl:pt-4 pt-4">
                <div className="flex gap-6 justify-between">
                  <div className="flex gap-2">
                    <div>
                      <img class="w-4" src={calendar1} alt="" />
                    </div>
                    <p className=" text-sm">May 16, 2024</p>
                  </div>

                  <div className="flex gap-2">
                    <div>
                      <img class="w-4" src={contact} alt="" />
                    </div>
                    <p className="text-sm">By JuniorToes</p>
                  </div>
                </div>
                <h2 class="font-bold  xl:pt-6 pt-4 xl:text-2xl text text-xl ">
                  All Inclusive Ultimate Circle Island Day
                </h2>
              </div>
              <div class="xl:pt-6 pt-4 flex justify-between items-center">
                <a
                  href="/grid"
                  class="text-peach text text-base font-semibold"
                >
                  Read More ➜
                </a>
              </div>
            </div>
          </div>

          <div>
            <div class=" rounded  shadow-lg bg-white xl:p-8 lg:p-6 p-6">
              <div class="image-container1">
                <img class="xl:w-12/12 w-12/12 rounded" src={blog4} alt="Blog Image" />
                <button class="exam-button flex">
                  <div>
                    <img className="w-6" src={folder} alt="" />
                  </div>
                  <span className="ml-2">Exam</span>
                </button>
              </div>

              <div class="xl:pt-4 pt-4">
                <div className="flex gap-6 justify-between">
                  <div className="flex gap-2">
                    <div>
                      <img class="w-4" src={calendar1} alt="" />
                    </div>
                    <p className=" text-sm">May 16, 2024</p>
                  </div>

                  <div className="flex gap-2">
                    <div>
                      <img class="w-4" src={contact} alt="" />
                    </div>
                    <p className="text-sm">By JuniorToes</p>
                  </div>
                </div>
                <h2 class="font-bold  xl:pt-6 pt-4 xl:text-2xl text text-xl ">
                  All Inclusive Ultimate Circle Island Day
                </h2>
              </div>
              <div class="xl:pt-6 pt-4 flex justify-between items-center">
                <a
                  href="/grid"
                  class="text-peach text text-base font-semibold"
                >
                  Read More ➜
                </a>
              </div>
            </div>
          </div>

          <div>
            <div class=" rounded  shadow-lg bg-white xl:p-8 lg:p-6 p-6">
              <div class="image-container1">
                <img class="xl:w-12/12 w-12/12 rounded" src={blog5} alt="Blog Image" />
                <button class="exam-button flex">
                  <div>
                    <img className="w-6" src={folder} alt="" />
                  </div>
                  <span className="ml-2">Exam</span>
                </button>
              </div>

              <div class="xl:pt-4 pt-4">
                <div className="flex gap-6 justify-between">
                  <div className="flex gap-2">
                    <div>
                      <img class="w-4" src={calendar1} alt="" />
                    </div>
                    <p className=" text-sm">May 16, 2024</p>
                  </div>

                  <div className="flex gap-2">
                    <div>
                      <img class="w-4" src={contact} alt="" />
                    </div>
                    <p className="text-sm">By JuniorToes</p>
                  </div>
                </div>
                <h2 class="font-bold  pt-4 xl:pt-6 xl:text-2xl text text-xl ">
                  All Inclusive Ultimate Circle Island Day
                </h2>
              </div>
              <div class="xl:pt-6 pt-4 flex justify-between items-center">
                <a
                  href="/grid"
                  class="text-peach text text-base font-semibold"
                >
                  Read More ➜
                </a>
              </div>
            </div>
          </div>

          <div>
            <div class=" rounded  shadow-lg bg-white xl:p-8 lg:p-6 p-6">
              <div class="image-container1">
                <img class="xl:w-12/12 w-12/12 rounded" src={blog6} alt="Blog Image" />
                <button class="exam-button flex">
                  <div>
                    <img className="w-6" src={folder} alt="" />
                  </div>
                  <span className="ml-2">Exam</span>
                </button>
              </div>

              <div class="xl:pt-4 pt-4">
                <div className="flex gap-6 justify-between">
                  <div className="flex gap-2">
                    <div>
                      <img class="w-4" src={calendar1} alt="" />
                    </div>
                    <p className=" text-sm">May 16, 2024</p>
                  </div>

                  <div className="flex gap-2">
                    <div>
                      <img class="w-4" src={contact} alt="" />
                    </div>
                    <p className="text-sm">By JuniorToes</p>
                  </div>
                </div>
                <h2 class="font-bold pt-4  xl:pt-6 xl:text-2xl text-xl text">
                  All Inclusive Ultimate Circle Island Day
                </h2>
              </div>
              <div class="xl:pt-6 pt-4 flex justify-between items-center">
                <a
                  href="/grid"
                  class="text-peach text text-base font-semibold"
                >
                  Read More ➜
                </a>
              </div>
            </div>
          </div>
        </div>
      </section>

      <Footer2 />
    </>
  );
}
